import { oids } from "@/configs/Settings";

/** `<oid>-<cnpj>` → `Organization/<oid>-<cnpj>`. */
export function organizationReferenceFromToken(organizationToken: string): string {
  return `Organization/${organizationToken}`;
}

/** `<oid>-<cnpj>` → `<cnpj>` (só dígitos, para exibição). */
export function cnpjFromOrganizationToken(organizationToken: string): string {
  return organizationToken.replace(`${oids.cnpj}-`, "");
}

/** Afiliação está em uso? Sem `active` gravado conta como ativa (mesma regra dos convênios). */
export function isAffiliationActive(
  affiliation: fhir5.OrganizationAffiliation,
): boolean {
  return affiliation.active !== false;
}
